import { render } from "./listRamification.vue?vue&type=template&id=0817ef5e"
import script from "./listRamification.vue?vue&type=script&lang=js"
export * from "./listRamification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__